exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2cilMDyA0taHDcrwOwhepg{max-width:400px}", ""]);
// Exports
exports.locals = {
	"optOutDialog": "_2cilMDyA0taHDcrwOwhepg"
};